/**
 * 表示周りの設定値定義
 */

// お知らせ画面の設定
export class NotificationSetting {
  static readonly INITIAL_LIMIT = 3
}

// プルダウンプレースホルダーの設定
export class InputItemPlaceholderSetting {
  static readonly REQUIRED = '選択必須'
  static readonly ALL = 'すべて'
  static readonly MANAGER_GRADE = '学年'
  static readonly MANAGER_GRADE_ALL = '学年：すべて'
  static readonly MANAGER_SUBJECT = '科目'
  static readonly MANAGER_ACADEMY = '塾名'
  static readonly MANAGER_BRANCH = '教室名'
  static readonly PRIORITY_ALL = '権限：すべて'
  static readonly YEAR_REQUIED = '実施年度：選択必須'
  static readonly MONTH_REQUIED = '実施月：選択必須'
}

// 画像一覧表示の設定
export class ImageListSetting {
  // 枠内に表示する画像数
  static readonly NUMBER_TO_DISPLAY = 4
}

/** 共通キャラクター設定 */
export class CommonCharacterSetting {
  /** 戻る系ボタン */
  static readonly PREV_BUTTON = '<'
  /** 進める系ボタン */
  static readonly NEXT_BUTTON = '>'
  /** 省略部分 */
  static readonly ELLIPSIS = '…'
  /** ハイフン表示 */
  static readonly HYPHEN = '-'
  /** 学習未実施等に表示するハイフン */
  static readonly EMPTY_CELL_LABEL = 'ー'
  /** 複数解答設問のセパレート記号 */
  static readonly ANSWER_SEPARATOR = '／'
  /** タブに表示する名称のセパレート記号 */
  static readonly TAB_NAME_SEPARATOR = '_'
  /** 可否の可 */
  static readonly POSSIBLE = '可'
  /** 可否の否 */
  static readonly NOT_POSSIBLE = '否'
  /** 注釈に使用する記号 */
  static readonly ANNOTATION_LABEL = '★'
}

// QRコードの縁取り表示に使用する設定
export class QrCodeLineSetting {
  static readonly QR_CODE_LINE_DRAW_COLOR = '#FF3B58'
  static readonly QR_CODE_LINE_DRAW_WIDTH = 4
}

export class PopupEditSetting {
  static readonly DELETE_CONFIRM_MESSAGE = '削除しますか？'
}

// 履歴周りの設定
export class ResultSetting {
  /** 得点の満点設定 */
  static readonly SCORE_PERFECT = 100
  /** スコアの満点設定 */
  static readonly ADJUST_SCORE_PERFECT = 300
  /** 大問のラベル */
  static readonly PROBLEM_NUMBER_LABEL = '大問'
  /** 大問の括弧 */
  static readonly PROBLEM_NUMBER_BRACKETS: string[] = ['〈', '〉']
  /** 小問の括弧 */
  static readonly QUESTION_NUMBER_BRACKETS: string[] = ['(', ')']
}

// 入力パターン設定
export class InputPatternSetting {
  // IDのパターン
  static readonly ACCOUNT_PATTERN: string = '^[a-zA-Z0-9]{1,20}$'
  // IDパターン不一致エラーメッセージ
  static readonly ACCOUNT_PATTERN_ERROR_MESSAGE: string = '半角英数字1〜20文字で入力してください。'
}
